import {Space} from "antd";
import Logo from "./Graphics/Logo";
import {DoubleLine} from "./Labels";
import React from "react";

const TickerChip = ({ticker, additionalItems, fontColor='#000', noGap=false,
                        imgSize=32, titleSize=14, textSize=11,
                        titleSuffix='', width=300, maxLength=30
                    })=>{
    return (
        <Space style={{width}}>
            <Logo src={ticker?.logo} height={imgSize} width={imgSize} borderRadius={'4px'} />
            <DoubleLine title={`${ticker?.symbol?.toUpperCase?.()??''} ${titleSuffix}`}
                        text={ticker?.name}
                        maxLength={maxLength}
                        titleSize={titleSize}
                        textSize={textSize}
                        textWeight={'400'}
                        fontColor={fontColor}
                        noGap={noGap}

            />
            {additionalItems}
        </Space>
    )
}

export default TickerChip;